export function getDeviceStylesIdentity(deviceType) {
  if (deviceType === 'phone') {
    return deviceType;
  }
  return 'desktop';
}
export function getDeviceStyles(deviceType) {
  if (deviceType === 'phone') {
    return require('./phone.module.css');
  }
  return require('./tablet-desktop.module.css');
}